export const barChartYes = "#BDEEFF";
export const barChartNo = "#19537B";
export const barChartUncertain = "#4A778D";
export const barChartNotAnswered = "#6BC5FF";
